/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsScoreRangeQueryOperator extends models.QueryOperator {
    getFixupPrototypeFunction() { return AppSecopsScoreRangeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsScoreRangeQueryOperator>): AppSecopsScoreRangeQueryOperator {
        let obj = Object.assign(new AppSecopsScoreRangeQueryOperator(), model);
        AppSecopsScoreRangeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsScoreRangeQueryOperator>): AppSecopsScoreRangeQueryOperator {
        if (!model) return null;
        return AppSecopsScoreRangeQueryOperator.newInstance(<AppSecopsScoreRangeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsScoreRangeQueryOperator) {
        if (!obj) return;

        models.AppSecopsScoreRangeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsScoreRangeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsScoreRangeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Minimum value for the score range
     */
    greater_than_or_equal_to: string;

    /**
     * Maximum value for the score range
     */
    less_than_or_equal_to: string;

    /**
     * Exact value for the score to match
     */
    equal_to: string;

}
